import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ai-result flex flex-col p-4" }
const _hoisted_2 = { class: "ai-result__text p-4 bg-inactive-bg rounded-lg" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-text-default"
}
const _hoisted_4 = {
  key: 1,
  class: "loading"
}
const _hoisted_5 = {
  key: 2,
  class: "ai-sources flex items-center mt-3 flex-wrap"
}
const _hoisted_6 = { class: "text-text-placeholder text-xs mt-1" }

import { onMounted, onBeforeUnmount } from 'vue';
import SearchAiSourceItem from '@/components/widgets/SearchAiSourceItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchAiResults',
  props: {
    aiGeneratedText: {},
    aiGenericLinks: {}
  },
  emits: ['hide-search-popup'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const translate = (key: string): string => {
  return key;
};

onMounted(() => {
  window.addEventListener('keydown', checkKey);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', checkKey);
});

const checkKey = (event: KeyboardEvent): void => {
  if (event.key === 'Escape') {
    hidePopup();
  }
};

const hidePopup = (): void => {
  emit('hide-search-popup');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.aiGeneratedText.length)
        ? (_openBlock(), _createElementBlock("pre", _hoisted_3, _toDisplayString(_ctx.aiGeneratedText), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _cache[1] || (_cache[1] = _createTextVNode()),
      (_ctx.aiGenericLinks.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(translate('sources')), 1),
            _cache[0] || (_cache[0] = _createTextVNode()),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aiGenericLinks, (source) => {
              return (_openBlock(), _createBlock(SearchAiSourceItem, {
                key: source.id,
                item: source,
                onHidePopup: hidePopup
              }, null, 8, ["item"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})